export const QUERY_PARAM_EXP_DWEB = 'QUERY_PARAM_EXP_DWEB';
export const PLP_INLINE_WIDGETS_DWEB = 'PLP_DNW_DWEB';
export const AB_CART_DFA = 'AB_CART_DFA';
export const AB_CART_FREE_SHIPPING = 'AB_CART_FREE_SHIPPING';
export const AB_EMPTY_CART = 'EMPTY_CART';
export const PDP_CARD_REVAMP = 'PDP_CARD_REVAMP';
export const PLP_IMG_RESIZE = 'PLP_IMG_RESIZE';
export const PLP_VARIANT_COLOR = 'PLP_VARIANT_COLOR';
export const AB_CART_BEST_COUPON = 'BEST_COUPON';
export const AB_FOOTER_CTA_TEXT = 'AB_FOOTER_CTA_TEXT';
export const AB_SEARCH_INP_ON_CART = 'SEARCH_INP_ON_CART';
export const AB_PRIVE_BAND = 'AB_PRIVE_BAND';
export const AB_GETAPP_DWEB = 'AB_GETAPP_DWEB';
export const CTA_DISABLE_DWEB = 'CTA_DISABLE_DWEB';
export const AB_CONVENIENCE_FEE = 'AB_CONVENIENCE_FEE';
export const AB_NYKAA_NOW_RAAP = 'AB_NYKAA_NOW_RAAP';
export const SECONDARY_TAGS_V2_DWEB = 'SECONDARY_TAGS_V2_DWEB';
export const DWEB_COLLAPSED_PRICE = 'DWEB_COLLAPSED_PRICE';
export const AB_AGG_FOOTER_SSR = 'AB_AGG_FOOTER_SSR';
